import { STRAPI_API } from "../config";
import Axios from 'axios';
const axios = Axios.create({
    baseURL: STRAPI_API
})

export function getStrapiAPI(path, params) {
    return new Promise((resolve) => {
        axios.get(path, {
            params
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            console.log (error);
            resolve(null);
        })
    })
}